import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, Divider, Drawer, Grid, Paper, Stack, Typography } from '@mui/material';
import { FaBars } from 'react-icons/fa6';
import { BARCODE_TOOLS, QR_TOOLS } from '../../data/tools';
import NavBar from './NavBar';
import ToolsSidebar from './ToolsSidebar';
import Footer from './Footer';

function AppLayout({ themeMode, onToggleTheme, children }) {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const activeTool = useMemo(() => {
    const allTools = [...QR_TOOLS, ...BARCODE_TOOLS];
    return allTools.find((tool) => tool.path === location.pathname);
  }, [location.pathname]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavBar themeMode={themeMode} onToggleTheme={onToggleTheme} />
      <Box
        component="main"
        sx={{
          flex: 1,
          px: { xs: 2, md: 4 },
          py: 3,
        }}
      >
        <Box sx={{ display: { xs: 'block', md: 'none' }, mb: 2 }}>
          <Paper
            sx={{
              p: 2,
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              background:
                themeMode === 'dark'
                  ? 'linear-gradient(135deg, rgba(27,29,34,0.92), rgba(27,29,34,0.6))'
                  : 'linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.75))',
              backdropFilter: 'blur(16px)',
              width: '100%',
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
              <Box>
                <Typography sx={{ fontWeight: 700 }}>Tools</Typography>
                <Typography variant="body2" color="text.secondary">
                  {activeTool ? activeTool.label : 'Choose a generator'}
                </Typography>
              </Box>
              <Button
                variant="contained"
                startIcon={<FaBars size={14} />}
                onClick={() => setDrawerOpen(true)}
              >
                Browse
              </Button>
            </Stack>
          </Paper>
        </Box>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }}>
            <Box sx={{ display: { xs: 'none', md: 'block' }, position: { md: 'sticky' }, top: { md: 96 } }}>
              <ToolsSidebar />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 9 }}>
            <Stack spacing={3}>{children}</Stack>
          </Grid>
        </Grid>
        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{
            sx: {
              px: 2,
              pt: 2,
              pb: 3,
              borderTopLeftRadius: 24,
              borderTopRightRadius: 24,
              backgroundColor: 'background.paper',
            },
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Tool Library
              </Typography>
              <Button variant="outlined" onClick={() => setDrawerOpen(false)}>
                Close
              </Button>
            </Stack>
            <ToolsSidebar variant="drawer" onNavigate={() => setDrawerOpen(false)} />
          </Stack>
        </Drawer>
      </Box>
      <Divider />
      <Footer />
    </Box>
  );
}

export default AppLayout;
